import Loader from 'components/Loader';
import { lazy, Suspense } from 'react';
import { FeatureFlag } from 'types/features';
import { ProtectedRoute } from './ProtectedRoute.tsx';

export const CONTACT_MERGE_PATH = '/contacts/merge';

const ContactMergeWizardPage = lazy(() => import('pages/contacts/merge/ContactMergeWizardPage'));

/** Outside `MainRoutes.tsx` so a test can render it, for the reason `meetingPrepViewRouteEntry.tsx` gives. */
export const contactMergeRouteElement = (
    <ProtectedRoute
        redirectPath="/contacts"
        element={
            <Suspense fallback={<Loader />}>
                <ContactMergeWizardPage />
            </Suspense>
        }
        permissions={['UPDATE.PARTIES.MERGE_CONTACTS']}
        requiredFeature={FeatureFlag.CONTACT_MERGING}
    />
);
